import { render } from "./Compras2.vue?vue&type=template&id=046d3fea"
import script from "./Compras2.vue?vue&type=script&lang=js"
export * from "./Compras2.vue?vue&type=script&lang=js"

import "./Compras2.vue?vue&type=style&index=0&id=046d3fea&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__